import { widgetDefinition } from "views/logic/Widgets";
import WidgetPosition from "views/logic/widgets/WidgetPosition";
import findGaps from "views/components/GridGaps";
const GetPositionForNewWidget = (widget, widgetPositions, _height = void 0, _width = void 0) => {
  var _a, _b;
  const { defaultHeight, defaultWidth } = widgetDefinition(widget.type);
  const height = _height != null ? _height : defaultHeight;
  const width = _width != null ? _width : defaultWidth;
  const lastStartingRow = (_a = widgetPositions.map((position) => position.row).max()) != null ? _a : 0;
  const finalRow = (_b = widgetPositions.map((position) => position.row + position.height).max()) != null ? _b : 0;
  const allGaps = findGaps(widgetPositions.valueSeq().toArray(), width);
  const gaps = allGaps.filter(
    (position) => position.row >= lastStartingRow && position.width >= width && position.height >= height
  );
  const newPosition = gaps[0] ? { row: gaps[0].row, col: gaps[0].col } : { row: finalRow + 1, col: 1 };
  return WidgetPosition.builder().height(height).width(width).col(newPosition.col).row(newPosition.row).build();
};
export default GetPositionForNewWidget;
